import React from 'react';
import classNames from 'classnames';

import { Context as SocketContext } from '../../../../components/Websocket';
import styles from './offline.scss';

const Offline = () => (
  <SocketContext.Consumer>
    {(values) => {
      const { online } = values || {};

      return (
        <div className={classNames(
          styles.indicator,
          { [styles.offline]: online === false },
        )}
        >
          { online === true
            && (
            <span>
              <i className="far fa-thumbs-up" />
              {' '}
              Back online!
            </span>
            )}
          { online === false
            && (
            <span>
              <i className="far fa-exclamation-circle" />
              {' '}
              It seems you&#39;re offline. Content might be unavailable.
            </span>
            )}
        </div>
      );
    }}
  </SocketContext.Consumer>
);

export default Offline;
